"use strict";
var FromEventPatternObservable_1 = require('./FromEventPatternObservable');
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/rxjs/observable/fromEventPattern.js
// module id = ../../../../rxjs/observable/fromEventPattern.js
// module chunks = 3